import React from "react";
import cn from "classnames";
import "./ExistingGetOfferBubble.less";

interface ExistingGetOfferBubbleProps {
    children: React.ReactNode;
    strikethroughTitle?: string;
    title?: string;
}

const ExistingGetOfferBubble: React.FC<ExistingGetOfferBubbleProps> = ({
    strikethroughTitle,
    title,
    children,
}: ExistingGetOfferBubbleProps) => {
    return (
        <div
            className={cn("existingGetOfferBubble", {
                ["existingGetOfferBubbleNoCampaign"]: true,
            })}
        >
            {strikethroughTitle && (
                <span className="existingGetOfferBubble__strikethroughData">{strikethroughTitle}</span>
            )}
            {title && <span className="existingGetOfferBubble__doubleData">{title}</span>}
            {children}
        </div>
    );
};

export default ExistingGetOfferBubble;
